function registerNodeFlow(Flow) {
    // 注册模型 流程节点
    Flow.registerNode('model-flow', {
        draw(item) {
            const group = item.getGraphicGroup();
            const model = item.getModel();
            const width = 120;
            const height = 60;
            const x = -width / 2;
            const y = -height / 2;
            const borderRadius = 4;
            const keyShape = group.addShape('rect', {
                attrs: {
                    x,
                    y,
                    width,
                    height,
                    radius: borderRadius,
                    fill: '#deebf6',
                    stroke: '#2e75B5'
                }
            });
            // 名称文本
            const label = model.label ? model.label : this.label;
            group.addShape('text', {
                attrs: {
                    text: label,
                    // x: x + 40,
                    // y: y + 25,
                    x: 0,
                    y: -5,
                    width,
                    height,
                    fontFamily: 'PingFang SC',
                    fontWeight: '500',
                    textAlign: 'center',
                    textBaseline: 'top',
                    fill: 'rgba(0,0,0,0.65)'
                }
            });
            // group.addShape('circle', {
            //     attrs: {
            //         x: -60,
            //         y: -(height * 0.25),
            //         r: 4,
            //         fill: '#1890FF'
            //     }
            // });
            return keyShape;
        },
        // 设置锚点
        anchor: [
            // [0.5, 0], // 上面边的中点
            // [0.5, 1] // 下边边的中点
        ]
    });
    // 流程节点
    Flow.registerNode('NODE_FLOW', {
        label: '流程节点',
        color_type: '#1890FF',
        // 设置锚点
        anchor: [
            [0, 0, {
                type: 'backOutput'
            }],
            // 上
            [0.5, 0, {
                type: 'input'
            }],
            // 右
            [1, 0.5, {
                type: 'output'
            }],
            // 下
            [0.5, 1, {
                type: 'input'
            }],
            // 左
            [0, 0.5, {
                type: 'input'
            }],
            [0, 1, {
                type: 'backOutput'
            }]
        ]
    }, 'model-flow');
}
// 创建人
function registerNodeCreateUser(Flow) {
    // 注册模型 创建人基类
    Flow.registerNode('model-create', {
        draw(item) {
            const group = item.getGraphicGroup();
            const model = item.getModel();
            const width = 120;
            const height = 60;
            const x = -width / 2;
            const y = -height / 2;
            const borderRadius = 30;
            const keyShape = group.addShape('rect', {
                attrs: {
                    x,
                    y,
                    width,
                    height,
                    radius: borderRadius,
                    color: '#c55a11',
                    fill: '#fbe5d5',
                    stroke: '#c55a11'
                }
            });
            // 名称文本
            const label = model.label ? model.label : this.label;
            group.addShape('text', {
                attrs: {
                    text: label,
                    // x: x + 40,
                    // y: y + 25,
                    x: 0,
                    y: -5,
                    width,
                    height,
                    fontFamily: 'PingFang SC',
                    fontWeight: '500',
                    textAlign: 'center',
                    textBaseline: 'top',
                    fill: 'rgba(0,0,0,0.65)'
                }
            });
            return keyShape;
        },
        // 设置锚点
        anchor: []
    });
    // NODE_KKK 分类
    Flow.registerNode('NODE_CREATE_USER', {
        label: '发起人',
        color_type: '#1890FF',
        // 设置锚点
        anchor: [
            // 上
            [0.5, 0, {
                type: 'backInput'
            }],
            // 右
            [1, 0.50, {
                type: 'output'
            }],
            // 下
            [0.5, 1, {
                type: 'backInput'
            }]
        ]
    }, 'model-create');
}
// 归档
function registerNodeArchive(Flow) {
    // 注册模型 归档基类
    Flow.registerNode('model-archive', {
        draw(item) {
            const group = item.getGraphicGroup();
            const model = item.getModel();
            const width = 120;
            const height = 60;
            // eslint-disable-next-line no-unused-vars
            const x = -width / 2;
            // eslint-disable-next-line no-unused-vars
            const y = -height / 2;
            // eslint-disable-next-line no-unused-vars
            const borderRadius = 5;
            // https://github.com/antvis/g#shapeimage
            const keyShape = group.addShape('path', {
                attrs: {
                    // width: 192,
                    // height: 192,
                    path: 'M0,0' +
                        // 上（上弧）
                        'M0 0 Q 60 -20 120 0' +
                        // 右
                        'M120 0 L 120 60' +
                        // 下
                        'M120 60 Q 60 80 0 60' +
                        // 左
                        'M0 60 L 0 0',
                    // 'M180 0 Q 90 0 0 0',
                    // 'z',
                    lineWidth: 1,
                    lineJoin: 'round',
                    fill: '#f2f2f2',
                    stroke: '#a5a5a5'
                    // img: 'http://127.0.0.1:11111/static/img/oa/NODE_CREATE_USER.png'
                    // img: 'https://qrcode.bdsaas.com/wx-app/static/img/NODE_ARCHIVE.png'
                }
            });
            group.addShape('rect', {
                attrs: {
                    x: 0,
                    y: 0,
                    width: 120,
                    height: 60,
                    fill: '#f2f2f2',
                    stroke: 'transparent'
                }
            });
            group.addShape('path', {
                attrs: {
                    path: 'M0,0' +
                        // 上 （下弧）
                        'M0 0 Q 60 20 120 0',
                    lineWidth: 1,
                    lineJoin: 'round',
                    fill: 'transparent',
                    stroke: '#a5a5a5'
                }
            });
            // 名称文本
            const label = model.label ? model.label : this.label;
            group.addShape('text', {
                attrs: {
                    text: label,
                    x: width / 2,
                    y: height / 2,
                    width,
                    height,
                    fontFamily: 'PingFang SC',
                    fontWeight: '500',
                    textAlign: 'center',
                    textBaseline: 'top',
                    fill: 'rgba(0,0,0,0.65)'
                }
            });
            return keyShape;
        },
        // 设置锚点
        anchor: [
            // [0.5, 0], // 上面边的中点
            // [0.5, 1] // 下边边的中点
        ]
    });
    // NODE_ARCHIVE 分类
    Flow.registerNode('NODE_ARCHIVE', {
        label: '发起人',
        color_type: '#1890FF',
        // 设置锚点
        anchor: [
            // 上
            [0.5, 0, {
                type: 'input'
            }],
            // 右
            [1, 0.50, {
                type: 'input'
            }],
            // 下
            [0.5, 1, {
                type: 'input'
            }],
            [0, 0.5, {
                type: 'input'
            }]
        ]
    }, 'model-archive');
}

export function registerNode(Flow) {
    registerNodeCreateUser(Flow);
    registerNodeFlow(Flow);
    registerNodeArchive(Flow);
}
